import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { Configurations } from '../../Utils/Configurations';
import axios from 'axios';
import './Modal-Pdfs-Adicionais.scss';
import update from 'immutability-helper';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';
import ImagemFukyo from '../../Components/Imagem-Fukyo/Imagem-Fukyo';




class ModalPdfsAdicionais extends React.Component {

    constructor(props) {
        super(props);
        this.handleOnInput = this.handleOnInput.bind(this);
        this.uploadArquivoAdicional = this.uploadArquivoAdicional.bind(this);
        this.removerArquivoAdicional = this.removerArquivoAdicional.bind(this);
        this.onSelectFile = this.onSelectFile.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.onSelectFileImage = this.onSelectFileImage.bind(this);
        this.uploadArquivoCapa = this.uploadArquivoCapa.bind(this);
        this.toggleModalPdfsAdicionais = this.toggleModalPdfsAdicionais.bind(this);
        this.indexUploadImagem = this.indexUploadImagem.bind(this);
        this.atualizaListaArquivos = this.atualizaListaArquivos.bind(this);
        this.toggleDownloadPDF = this.toggleDownloadPDF.bind(this)

        this.Configurations = new Configurations();

        this.state = {
            isLoadingDelete: false,
            exibeUpload: true,
            sucessoUpload: false,
            modalPdfsAdicionais: this.props.modalPdfsAdicionais,
            titulo: '',
            secao: '',
            isLoadingUploadAdicional: false,
            hasError: false,
            errorMessage: '',
            copiaArray: [],
            exibeUploadCapa: false,
            loadingDownload: false

        }

    }

    componentDidUpdate(prevProps) {
        if (prevProps.arquivosAdicionais !== this.props.arquivosAdicionais) {
            this.setState({
                copiaArray: this.props.arquivosAdicionais
            })
        }
    }

    uploadArquivoAdicional() {
        this.setState({ isLoadingUploadAdicional: true })
        const { numEdicao, periodico } = this.props,
            formData = new FormData();

        formData.append("fileUpload", this.state.fileUpload);
        formData.append("titulo", this.state.titulo);
        // formData.append("tituloImagem", this.state.tituloImagem);
        formData.append("secao", this.state.secao)
        axios.post(this.Configurations.apiBasePath + `/conteudo/edicoes/${periodico}/${numEdicao}/upload/artigo`, formData, {
            headers: {
                "Content-Type": `multipart/form-data`,
            }
        }).then(response => {
            this.setState({
                arquivoAdicional: response.data.urlPublica,
                sucessoUpload: true,
                sucessoDelete: false,
                exibeUpload: true,
                fileUpload: undefined,
                titulo: '',
                secao: '',
                tituloImagem: ''
            })
            this.props.carregaArtigos();
        }).catch(this.handleError).finally(() => this.setState({ isLoadingUploadAdicional: false }));
    }



    handleOnInput(e) {
        e.preventDefault();
        this.setState({ [e.target.name]: e.target.value })
    }

    onSelectFile(e) {
        this.setState({ fileUpload: e.target.files[0] })
    };

    onSelectFileImage(e) {
        this.setState({ fileUploadCapaArquivo: e.target.files[0] })
    };

    removerArquivoAdicional(idArquivoAdicional, index) {
        const { numEdicao, periodico } = this.props;
        const body = { idArquivoAdicional }
        this.setState({ copiaArray: this.props.arquivosAdicionais }, () => {
            this.setState({
                copiaArray: update(this.state.copiaArray, { [index]: { isLoadingDelete: { $set: true } } })
            })
        })
        axios.post(this.Configurations.apiBasePath + `/conteudo/edicoes/${periodico}/${numEdicao}/excluir/artigo`, body).then(response => {
            this.setState({
                sucessoUpload: false,
                sucessoDelete: true,
                exibeUpload: true,
                fileUpload: undefined,
                arquivoAdicional: response.data.arquivo
            }, () => this.atualizaListaArquivos(response.data.listaAtualizada))
        }).catch(this.handleError).finally(() => {
            if (!!this.state.copiaArray && this.state.copiaArray.length > 0) {
                this.setState({ copiaArray: update(this.state.copiaArray, { [index]: { isLoadingDelete: { $set: false } } }) })
            }
        });
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.message })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    onSelectFileCoverPageEdition(o) {
        this.setState({ fileUploadCapaArquivo: o.target.files[0] })
    };

    uploadArquivoCapa(idArquivoAdicional) {
        this.setState({ isLoadingUploadCapaArquivo: true })
        const formData = new FormData();

        formData.append("imagem", this.state.fileUploadCapaArquivo);
        axios.post(this.Configurations.apiBasePath + `/imagem-pdf/${idArquivoAdicional}`, formData, {
            headers: {
                "Content-Type": `multipart/form-data`,
            }
        }).then(response => {
            this.setState({
                fileUploadCapaArquivo: undefined,
                indexUploadImagem: undefined
            }, () => this.atualizaListaArquivos(response.data.listaAtualizada))
        }).catch(this.handleError).finally(() => this.setState({ isLoadingUploadCapaArquivo: false }));
    }

    removerArquivoCapa() {
        this.setState({ isLoadingDeleteCapaArquivo: true })
        // const { numEdicao, periodico } = this.props.match.params;
        // _filename = this.state.arquivoEdicao.split("https://storage.googleapis.com/edicoes-periodicos/")[1];
        // axios.post(this.Configurations.apiBasePath + `/conteudo/edicoes/${periodico}/${numEdicao}/excluir`).then(response => {
        this.setState({
            sucessoUploadCapaArquivo: false,
            sucessoDeleteCapaArquivo: true,
            exibeUploadCapaArquivo: false,
            fileUploadCapaArquivo: undefined,
            capaEdicao: undefined,
            modalRemoverArquivoCapa: false,
        })
        // }).catch(this.handleError).finally(() => 
        this.setState({ isLoadingDeleteCapaArquivo: false })
        // );
    }

    toggleModalPdfsAdicionais() {
        this.setState({
            indexUploadImagem: undefined
        }, () => this.props.toggle())
    }

    indexUploadImagem(index) {
        this.setState({
            // exibeUploadCapaImagem: true, 
            // sucessoUpload: false, 
            // sucessoDelete: false,
            indexUploadImagem: index
        })
    }

    atualizaListaArquivos(lista) {
        this.props.atualizaLista(lista);
    }

    toggleDownloadPDF(idPDF, infoDownload) {
        this.setState({
            loadingDownload: true
        })
        const { numEdicao, periodico } = this.props;

        const body =
        {
            "idArquivoAdicional": idPDF,
            "downloadHabilitado": !infoDownload
        }

        axios.post(this.Configurations.apiBasePath + `/conteudo/edicoes/${periodico.toUpperCase()}/${numEdicao}/status-download`, body, {
        }).then(response => {
            this.setState({
                copiaArray: response.data.listaAtualizada,
                loadingDownload: false
            })
        }).catch(this.handleError).finally(() => this.setState({ loadingDownload: false }));
    }

    render() {
        const {
            isOpen,
            isLoadingArtigos
        } = this.props;
        return (
            <React.Fragment>
                {isOpen && (
                    <div className='row'>
                        <div className='col-12'>
                            <Modal className="modal-pdfs-adicionais" size="lg" isOpen={isOpen} toggle={this.toggleModalPdfsAdicionais}>
                                <ModalHeader toggle={this.toggleModalPdfsAdicionais}>PDFs adicionais</ModalHeader>
                                <ModalBody>
                                    <div className='row'>
                                        <div className='col-12'>
                                            {isLoadingArtigos ? (
                                                <React.Fragment>
                                                    <div className='row text-center'>
                                                        <div className='col-12'>
                                                            <div className="spinner-border text-primary" role="status" />
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            ) : (
                                                <React.Fragment>
                                                    <div className='row'>
                                                        <div className='col-12'>
                                                            {this.state.copiaArray.length <= 0 && (
                                                                <React.Fragment>
                                                                    <div className='row text-primary text-center'>
                                                                        <div className='col-12'>
                                                                            <span>Não existem PDFs adicionais cadastrados para essa edição.</span>
                                                                        </div>
                                                                    </div>
                                                                </React.Fragment>
                                                            )}
                                                            {this.state.copiaArray.length > 0 && (
                                                                <React.Fragment>
                                                                    <div className='row lista-arquivos text-center'>
                                                                        <div className='col-12'>
                                                                            <p>Lista de arquivos</p>
                                                                        </div>
                                                                    </div>

                                                                    <div className="row lista-arquivos-pdfs-adicionais">
                                                                        {!!this.state.copiaArray && this.state.copiaArray.length > 0 && (
                                                                            <React.Fragment>
                                                                                {this.state.copiaArray.map((item, index) => {
                                                                                    return (
                                                                                        <div key={`i-${index}`} className='col-10 offset-1 py-2'>
                                                                                            <div className='card'>
                                                                                                <div className='card-body'>
                                                                                                    <div className='col-12'>
                                                                                                        <div className='row'>
                                                                                                            <div className='col-md-3'>
                                                                                                                <div className='row'>
                                                                                                                    {/* <div className='col-12 d-none d-lg-block pointer' onClick={() => window.open(`item.url`)}> */}
                                                                                                                    <div className='col-12 d-none d-lg-block pointer' onClick={() => window.open(item.imagem)}>

                                                                                                                        <ImagemFukyo
                                                                                                                            className={`img-imagem-artigo img img-fluid`}
                                                                                                                            src={item.imagem}
                                                                                                                            alt={"imagem do artigo"}
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div className='col-md-6'>
                                                                                                                <div className='row'>
                                                                                                                    <div className='col-12'>
                                                                                                                        <p className="m-0 text-truncate"><strong>Título: </strong>{item.titulo}</p>
                                                                                                                    </div>
                                                                                                                    <div className='col-12'>
                                                                                                                        <p className="m-0 text-truncate"> <strong>Seção: </strong>{item.secao} </p>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div className='col-md-3'>
                                                                                                                <div className='row'>
                                                                                                                    <div className='col-12 py-1 text-right'>
                                                                                                                        <span className="m-0 text-truncate"> <a target="_blank" rel="noopener noreferrer" href={item.arquivo}><i className="far fa-file-pdf mr-1 text-primary"></i><span className="text-primary">visualizar PDF</span></a></span>
                                                                                                                    </div>
                                                                                                                    <div className='col-12 py-1 text-right'>
                                                                                                                        {item.isLoadingDelete ? (
                                                                                                                            <div className="spinner-border text-primary text-center" role="status" />
                                                                                                                        ) : (
                                                                                                                            <span onClick={() => this.removerArquivoAdicional(item._id, index)} className="cursor-pointer">
                                                                                                                                <i className={'far fa-trash-alt mr-1 text-danger'}></i><span className="text-danger">remover PDF</span>
                                                                                                                            </span>
                                                                                                                        )}
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className='row'>
                                                                                                        <div className='col-6 text-left py-2'>
                                                                                                            <span className="cursor-pointer py-2">
                                                                                                                <i className={'fas fa-file-image mr-1 text-success'}></i><span className="text-success" onClick={() => this.indexUploadImagem(index)}>alterar imagem</span></span>
                                                                                                        </div>
                                                                                                        <div className='col-6 py-2'>
                                                                                                            <p
                                                                                                                className={`cursor-pointer d-flex align-items-center justify-content-end ${item.downloadHabilitado ? 'text-info' : 'text-secondary'}`}
                                                                                                                onClick={() => this.toggleDownloadPDF(item._id, item.downloadHabilitado)}
                                                                                                            >
                                                                                                                Download habilitado 
                                                                                                                {this.state.loadingDownload ? <div className="spinner-border spinner-border-sm ml-2 text-info" role="status" />
                                                                                                                    :
                                                                                                                    <i className={`fas ${item.downloadHabilitado ? 'fa-toggle-on' : 'fa-toggle-off'} ml-2 icon-toggle`} />
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    {index === this.state.indexUploadImagem && (
                                                                                                        <div className="col-12 col-lg-12 text-center text-lg-left py-2 d-align-items-center d-lg-block d-none">
                                                                                                            <div className="row">
                                                                                                                <div className="col-12">
                                                                                                                    <input type="file" accept=".jpg,.jpeg,.png" className="input-capa-edicao" onChange={this.onSelectFileImage} />
                                                                                                                    {this.state.isLoadingUploadCapaArquivo ? (
                                                                                                                        <div className="spinner-border text-primary" role="status" />
                                                                                                                    ) : (
                                                                                                                        <button disabled={!this.state.fileUploadCapaArquivo} onClick={() => this.uploadArquivoCapa(item._id)} className="btn btn-outline-success mx-2">upload imagem</button>
                                                                                                                    )}
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    )
                                                                                })}
                                                                            </React.Fragment>
                                                                        )}

                                                                    </div>
                                                                    {/*Layout mobile*/}
                                                                    <div className='row'>
                                                                        <div className='col-12 d-lg-none'>
                                                                            <table className="tabela-lista-arquivos table w-100 text-left table-bordered">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th className='text-center'>Titulo</th>
                                                                                        <th className='text-center'>Seção</th>
                                                                                        <th></th>
                                                                                        <th></th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {!!this.state.copiaArray && this.state.copiaArray.length > 0 && (
                                                                                        <React.Fragment>
                                                                                            {this.state.copiaArray.map((item, index) => {
                                                                                                return (
                                                                                                    <tr key={index}>
                                                                                                        <td className='text-center'>{item.titulo}</td>
                                                                                                        <td className='text-center'>{item.secao}</td>
                                                                                                        <td className='text-center'><a target="_blank" rel="noopener noreferrer" href={item.arquivo}><i className="far fa-file-pdf ml-2 mr-1 text-primary"></i><span className="text-primary"></span></a></td>

                                                                                                        <td className='text-center'>
                                                                                                            {item.isLoadingDelete ? (
                                                                                                                <div className="spinner-border text-primary text-center" role="status" />
                                                                                                            ) : (
                                                                                                                <span onClick={() => this.removerArquivoAdicional(item._id, index)} className="cursor-pointer">
                                                                                                                    <i className={'far fa-trash-alt ml-3 mr-1 text-danger'}></i><span className="text-danger"></span>
                                                                                                                </span>
                                                                                                            )}
                                                                                                        </td>
                                                                                                    </tr>
                                                                                                )
                                                                                            })}
                                                                                        </React.Fragment>
                                                                                    )}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </React.Fragment>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {/*Layout desktop*/}
                                                    <div className='row border-bottom border-secondary py-2'>
                                                    </div>
                                                    <div className='row novo-arquivo text-center py-3'>
                                                        <div className='col-12'>
                                                            <p>Novo arquivo</p>
                                                        </div>
                                                    </div>
                                                    <div className='row'>
                                                        <div className='col-12'>
                                                            {this.state.exibeUpload && (
                                                                <React.Fragment>
                                                                    <div className="col-12 col-lg-12 text-center text-lg-left py-2 px-3 d-align-items-center d-none d-lg-block">
                                                                        <div className="row py-2">
                                                                            <div className="col-6 py-2">
                                                                                <label><small>* informações obrigatórias</small></label>
                                                                                <input type="file" accept=".pdf" className="input-arquivo b" onChange={this.onSelectFile} />
                                                                            </div>
                                                                            <div className='col-3'>
                                                                                <label>Título<sup>*</sup></label>
                                                                                <input name="titulo" value={this.state.titulo} className='form-control' type="text" onChange={this.handleOnInput} autoComplete="off"></input>
                                                                            </div>
                                                                            <div className='col-3'>
                                                                                <label>Seção<sup>*</sup></label>
                                                                                <input name="secao" value={this.state.secao} className='form-control' type="text" onChange={this.handleOnInput} autoComplete="off"></input>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-12 text-right py-1 d-none d-lg-block'>
                                                                        {this.state.isLoadingUploadAdicional ? (
                                                                            <div className="spinner-border text-primary" role="status" />
                                                                        ) : (
                                                                            <button disabled={!this.state.fileUpload} className="btn btn-outline-success mx-2" onClick={this.uploadArquivoAdicional}>upload PDF</button>
                                                                        )}
                                                                    </div>
                                                                </React.Fragment>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {/*Layout mobile*/}
                                                    <div className='row'>
                                                        <div className='col-12'>
                                                            {this.state.exibeUpload && (
                                                                <React.Fragment>
                                                                    <div className="col-12 text-left  py-2 px-3 d-align-items-center d-lg-none">
                                                                        <div className="row py-2">
                                                                            <div className="col-12 py-2">
                                                                                <label><small>* informações obrigatórias</small></label>
                                                                                <input type="file" accept=".pdf" className="input-arquivo b" onChange={this.onSelectFile} />
                                                                            </div>
                                                                            <div className='col-6 text-left'>
                                                                                <label>Título<sup>*</sup></label>
                                                                                <input name="titulo" value={this.state.titulo} className='form-control' type="text" onChange={this.handleOnInput} autoComplete="off"></input>
                                                                            </div>
                                                                            <div className='col-6 text-left'>
                                                                                <label>Seção<sup>*</sup></label>
                                                                                <input name="secao" value={this.state.secao} className='form-control' type="text" onChange={this.handleOnInput} autoComplete="off"></input>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-12 text-right py-3 d-lg-none'>
                                                                        {this.state.isLoadingUploadAdicional ? (
                                                                            <div className="spinner-border text-primary" role="status" />
                                                                        ) : (
                                                                            <button disabled={!this.state.fileUpload} className="btn btn-outline-success mx-2" onClick={this.uploadArquivoAdicional}>upload PDF</button>
                                                                        )}
                                                                    </div>
                                                                </React.Fragment>
                                                            )}
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            )}
                                        </div>
                                    </div>

                                </ModalBody >
                            </Modal >
                        </div >
                        <ErrorModal
                            isOpen={this.state.hasError}
                            message={this.state.errorMessage}
                            closeErrorModal={this.closeErrorModal}
                            goBack={!this.state.hasError}
                        />
                    </div >
                )
                }
            </React.Fragment>


        )
    }
}

export default ModalPdfsAdicionais;